import React from "react";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";

import {
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead
} from "../../styles/styledTable";

import MasterBalancesItem from "./MasterBalancesItem";

const MasterBalancesList = ({ t, balances, setFetch }) => {

  if (!balances) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (balances.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable className="master-balances_scroll">
      <StyledTable
        width="992"
        size="14"
        className="master-balances-table"
      >
        <StyledTableHead
          scroll="auto"
          col="4"
          className="master-balances-table__head"
        >
          <div>
            {t("table.currency")}
          </div>
          <div>
            {t("table.service")}
          </div>
          <div>
            {t("table.amount")}
          </div>
          <div>
            {t("table.actions")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {balances && balances.map((value, key) => (
            <MasterBalancesItem
              t={t}
              key={key}
              value={value}
              setFetch={setFetch}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};
export default MasterBalancesList;